


















import { computed, defineComponent } from '@vue/composition-api';

import errorsConfig from '~/types/errorsConfig';

export default defineComponent({
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    let errorCode: string = props.error.statusCode.toString().substring(0, 1);

    // Przygotowane są tylko dwie strony errorów
    // wszystko co NIE jest błędem "500" przyjmuje postać błędu "400"
    if (!(errorCode === '5')) {
      errorCode = '4';
    }

    const errorConfig = errorsConfig[errorCode];
    const scssVars = computed(() => ({
      '--img-lg': `url(${errorConfig.imgLg})`,
      '--img-md': `url(${errorConfig.imgMd})`,
      '--img-sm': `url(${errorConfig.imgSm})`,
    }));

    return {
      errorMessage: errorConfig.message,
      errorCode: props.error.statusCode,
      scssVars: scssVars.value,
    };
  },
});
